import { Component } from '@angular/core';
import { soundpostCustomerEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'Customers') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-soundpostcustomer-form',
    templateUrl: './soundpostcustomer.form.component.html'
})
export class soundpostCustomerFormComponent extends BaseFormComponent {
    public record!: soundpostCustomerEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

